var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncommingInvoiceProcess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 18V17V5C8 3.89543 8.89543 3 10 3H33C34.1046 3 35 3.89543 35 5V34C35 35.1046 34.1046 36 33 36H23.5V19.1476C23.5 18.5135 22.9711 18 22.318 18H8Z",
    fill: "#4570FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 24V17L39.5 20L35 24Z",
    fill: "#1BA2D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0164 28.317L36.2059 22.4662L39.5 20V41H35.9739H33.9141L23.5 40.8967V39.236V36.7699V32.824L29.0164 28.317Z",
    fill: "#73D7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68923 20V42.0077H4.62926C4.62926 41.0393 5.41706 40.2278 6.39243 40.2278C7.36781 40.2278 8.15561 41.0393 8.15561 42.0077H10.3314C10.3314 41.0393 11.1192 40.2278 12.0946 40.2278C13.07 40.2278 13.8578 41.0393 13.8578 42.0077H16.0336C16.0336 41.0393 16.8214 40.2278 17.7968 40.2278C18.7722 40.2278 19.56 41.0393 19.56 42.0077H21.5V20H2.69459H2.68923Z",
    fill: "#00ACEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.992 26.4291L15.5023 29.612H5.74854L5.74854 31.5594H15.4969L11.992 34.7422L13.3532 36.1661L19.5002 30.5857L13.3532 25L11.992 26.4291Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    rx: 1,
    transform: "matrix(-1 0 0 1 29 8)",
    fill: "#FFDD64"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    rx: 1,
    transform: "matrix(-1 0 0 1 29 13)",
    fill: "#FFDD64"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    rx: 1,
    transform: "matrix(-1 0 0 1 29 19)",
    fill: "#FFDD64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncommingInvoiceProcess);
export default __webpack_public_path__ + "static/media/incomming-invoice-process.fe43e7720a83a4cd4763dee4d9eda857.svg";
export { ForwardRef as ReactComponent };